import React from "react";

import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import OrdersIcon from "@material-ui/icons/Receipt";
import UsersIcon from "@material-ui/icons/SupervisorAccount";
import ClientsIcon from "@material-ui/icons/Business";
import BuildIcon from "@material-ui/icons/Build";
import SettingsIcon from "@material-ui/icons/Settings";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import Power from "@material-ui/icons/PowerOff"
import InfoIcon from "@material-ui/icons/Info"
import UserService from "../../services/users";
import InfoHoliday from "@material-ui/icons/BeachAccess"
 import MessagesIcon from '@material-ui/icons/Message';
 import AgendaIcon from '@material-ui/icons/CalendarToday';
class Menu extends React.Component {
  self = this;
  constructor(props) {
    super(props);

    this.openPage = this.openPage.bind(this);
  }

  openPage = (pages) => {
    this.props.handleOpen(false);
    window.location.href = "#/" + pages;
  }

  logout() {
    UserService.logout();
    window.location.href = "#";
  }

  render() {
    if (!this.props.menuitems) {
      return null;
    }
    let currentUser = UserService.currentUser();
    let Clothes = <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24"><path d="M280 976V727h-71q-36 0-62.5-24.5T120 642q0-27 13.5-50.5T172 557l281-120v-42q-37-10-60.5-40.5T369 286q0-46 33-78t79-32q46 0 79 32t33 78h-60q0-21-15.5-35.5T481 236q-21 0-36.5 14.5T429 286q0 23 15.5 38.5T483 340q12 0 21 8.5t9 20.5v68l275 120q25 11 38.5 34.5T840 642q0 36-26.5 60.5T751 727h-71v249H280Zm60-300h280-280Zm-131-9h71v-51h400v51h71q11 0 20-7.5t9-18.5q0-9-5-16t-13-11L483 488 198 614q-8 4-13 11t-5 15q0 11 8.5 19t20.5 8Zm131 249h280V676H340v240Z" fill="#6c6c6c"/></svg>
 

    const icons = [];
    icons["mail"] = <MailIcon />;
    icons["workorders"] = <OrdersIcon />
    icons["clients"] = <ClientsIcon />
    icons["users"] = <UsersIcon />
    icons["projects"] = <BuildIcon />
    icons["settings"] = <SettingsIcon />
    icons["attachmoney"] = <AttachMoneyIcon />
    icons["power"] = <Power />
    icons["info"] = <InfoIcon/>
    icons["holiday"] = <InfoHoliday/>
    icons["messages"] = <MessagesIcon/>
    icons["agenda"] = <AgendaIcon/>
    
    const menuItems = (
      <div>
        <List>
          {this.props.menuitems.map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={() => this.openPage(item.link)}
            >
              <ListItemIcon>{icons[item.icon]}</ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}
          <Divider />
          
      
          <ListItem
            button
            onClick={(ev) => {ev.preventDefault(); window.open("https://bestel.lenmworkwear.nl/")}}
          >
            <ListItemIcon>{Clothes}</ListItemIcon>
            <ListItemText primary="Kleding bestellen" /></ListItem>
            <Divider />
            <ListItem
            button
            onClick={() => this.openPage('messages')}
          >
            <ListItemIcon>{icons['messages']}</ListItemIcon>
            <ListItemText primary={"Berichten" + (this.props.unread ? ` (${this.props.unread} ongelezen)`:``)} /></ListItem>
          <ListItem
            button
            onClick={() => this.openPage('info')}
          >
            <ListItemIcon>{icons['info']}</ListItemIcon>
            <ListItemText primary="Info" /></ListItem>

        
      

          <ListItem
            button
            onClick={() => this.logout()}
          >
            <ListItemIcon>{icons['power']}</ListItemIcon>
            <ListItemText primary="Uitloggen" /></ListItem>
        </List>

      </div>
    );

    return (
      <div>
        <Drawer
          open={this.props.open}
          onClose={() => this.props.handleOpen(false)}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={() => this.props.handleOpen(false)}
            onKeyDown={() => this.props.handleOpen(false)}
          >
            <img src="images/aral-logo.png" alt="ARAL Lasservice" style={{ width: '250px', padding: '20px', display: 'inline-block' }} />
            {menuItems}
            {currentUser && <div className="versioninfo">Ingelogd als  {currentUser.firstname}</div>}
            <div className="versioninfo">Versie 1.19.1</div>
          </div>
        </Drawer>
      </div>
    );
  }
}
export default Menu;
